import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters'
import axios from "axios";
// axios.defaults.withCredentials = true
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
        platform: localStorage.getItem('platform') ? JSON.parse(localStorage.getItem('platform')) : {},
        banner: localStorage.getItem('banner') ? JSON.parse(localStorage.getItem('banner')) : ['//cos.yzspeixun.com/resources/banner/2.png','//cos.yzspeixun.com/resources/banner/banner3.png']
    },
    mutations: {
        changeLogin(state, user) {
            state.Authorization = user.Authorization;
            localStorage.setItem("Authorization", user.Authorization);
            axios.get(Vue.prototype.$managePath + '/offline/api/userInfo').then(res => {
                state.user = res.data.data || null;
                if (state.user) {
                    for (let id in state.user.customOrgIdsAndNames || []) {
                        state.user.customOrgId = id;
                        state.user.customOrgName = state.user.customOrgIdsAndNames[id];
                    }
                    localStorage.setItem("user", JSON.stringify(state.user));
                }
            });
        },
        clearAuthor(state) {
            state.user = null;
            state.Authorization = null;
        },
        setPlatform(state, platform) {
            localStorage.setItem("platform", JSON.stringify(platform));
            state.platform = platform
        },
        setBanner(state,banner){
            localStorage.setItem("banner", JSON.stringify(banner));
            state.banner = banner
        }
    },
    getters
})

export default store;




// WEBPACK FOOTER //
// ./src/store/index.js